// extracted by mini-css-extract-plugin
export default {"info":"Info_info__8yZ25","text":"Info_text__TvQm1"};